/**
 * Wraps a promise in setTimeout. Will reject if the given promise doesn't resolve before the timeout.
 * @param promise
 * @param timeout
 * @param error optional rejection reason
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function timeoutPromise<T>(promise: Promise<T>, timeout: number, error?: string | Error): Promise<T> {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(error);
    }, timeout);
    promise.then(resolve, reject);
  });
}
